import {
  FormViewConfig,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
} from "../../../../records/forms/formView";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";

export const vsObjectName = "gamingContractMasterAgreementAmendment";

GamingContractMasterAgreementAmendmentConfig.$inject = [
  FormViewServiceProviderName,
];

export function GamingContractMasterAgreementAmendmentConfig(
  formViewServiceProvider: FormViewServiceProvider
) {
  configureForm(formViewServiceProvider);
}

function configureForm(formViewServiceProvider: FormViewServiceProvider) {
  formViewServiceProvider.addFormViewConfig(vsObjectName, [
    (): FormViewConfig => {
      return {
        name: vsObjectName,
        fields: [
          ...fieldHelpers.columnLayout(
            [
              {
                key: "AmendmentDate",
                type: "datepicker",
                templateOptions: {
                  label: "Amendment Date",
                  required: true,
                },
              },
            ],
            4
          ),
          fieldHelpers.headerField({
            headerText: "Files",
            key: "FilesHeader",
          }),
          {
            key: "Files",
            type: "recordFileUpload",
            templateOptions: {
              label: "Files",
              allowMultiple: true,
              hideLabel: true,
            },
          },
          fieldHelpers.headerField({
            headerText: "Executed Contract",
            key: "ExecutedContractHeader",
          }),
          ...fieldHelpers.columnLayout(
            [
              fieldHelpers.simpleSingleFileUpload({
                key: "ExecutedContract",
                label: " ",
                required: false,
              }),
            ],
            2
          ),
          fieldHelpers.headerField({
            headerText: "Notes",
            key: "NotesHeader",
          }),
          fieldHelpers.textAreaField({
            key: "Notes",
            name: "Notes",
            label: " ",
            rows: 5,
          }),
        ],
        title: () => "Master Agreement Amendment",
      };
    },
  ]);
}
